"use client";

const Arrow = ({
  color = "#171C60",
  direction = "right",
  className,
}: {
  color?: string;
  direction?: "left" | "right" | "up" | "down";
  className?: string;
}) => {
  const getTransform = (direction: "left" | "right" | "up" | "down") => {
    if (direction === "left") return "rotate(180deg)";
    if (direction === "up") return "rotate(-90deg)";
    if (direction === "down") return "rotate(90deg)";
    return "";
  };

  const handleScrollDown = () => {
    window.scrollBy({
      top: 500,
      behavior: "smooth",
    });
  };

  return (
    <svg
      style={{
        transform: getTransform(direction),
      }}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={direction === "down" ? handleScrollDown : undefined}
      role="button"
      aria-label="Scroll naar beneden"
    >
      <g id="arrow">
        <path
          id="Arrow 3"
          d="M5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13V11ZM19.7071 12.7071C20.0976 12.3166 20.0976 11.6834 19.7071 11.2929L13.3431 4.92893C12.9526 4.53841 12.3195 4.53841 11.9289 4.92893C11.5384 5.31946 11.5384 5.95262 11.9289 6.34315L17.5858 12L11.9289 17.6569C11.5384 18.0474 11.5384 18.6805 11.9289 19.0711C12.3195 19.4616 12.9526 19.4616 13.3431 19.0711L19.7071 12.7071ZM5 13H19V11H5V13Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default Arrow;
